import React from 'react';
import PageLayout from '../../components/PageLayout';
import Location from '../../components/master/Location';


interface MasterPageProps {
  onLogout?: () => void;
  currentPage?: string;
  onNavigate?: (page: string) => void;
}

const LocationPage: React.FC<MasterPageProps> = ({ onLogout, currentPage, onNavigate }) => {

  return (
    <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
      <Location />
    </PageLayout>
  );
};

export default LocationPage;
